import { useEffect } from 'react';

const isEditableElement = (element: Element | null): boolean =>
  element instanceof HTMLInputElement
  || element instanceof HTMLTextAreaElement
  || element instanceof HTMLSelectElement
  || (element instanceof HTMLElement && element.isContentEditable);

export function ViewportManager() {
  useEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;

    const updateViewport = () => {
      const height = viewport?.height ?? window.innerHeight;
      root.style.setProperty('--app-height', `${Math.round(height)}px`);

      const hasEditableFocus = isEditableElement(document.activeElement);
      const isViewportReduced = viewport
        ? viewport.height < window.innerHeight - 120
        : false;
      root.dataset.keyboardOpen = String(hasEditableFocus && isViewportReduced);
    };

    const handleFocusChange = () => window.requestAnimationFrame(updateViewport);

    updateViewport();
    viewport?.addEventListener('resize', updateViewport);
    viewport?.addEventListener('scroll', updateViewport);
    window.addEventListener('resize', updateViewport);
    document.addEventListener('focusin', handleFocusChange);
    document.addEventListener('focusout', handleFocusChange);

    return () => {
      viewport?.removeEventListener('resize', updateViewport);
      viewport?.removeEventListener('scroll', updateViewport);
      window.removeEventListener('resize', updateViewport);
      document.removeEventListener('focusin', handleFocusChange);
      document.removeEventListener('focusout', handleFocusChange);
      delete root.dataset.keyboardOpen;
      root.style.removeProperty('--app-height');
    };
  }, []);

  return null;
}
